/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IHouseOfferHistoryDesktopSchema } from '../../entities/offer_history/HouseOfferHistoryDesktopSchema';
import { IOfferHistoryRoomCountItemSchema } from '../../entities/offer_history/OfferHistoryRoomCountItemSchema';
import { IOfferHistoryStatusCountItemSchema } from '../../entities/offer_history/OfferHistoryStatusCountItemSchema';

export type TGetHouseOfferHistoryDesktopModel = IModel<
  IGetHouseOfferHistoryDesktopRequest,
  TGetHouseOfferHistoryDesktopResponse
>;

export interface IGetHouseOfferHistoryDesktopRequest {
  /** Тип сделки **/
  dealType: EDealType;
  /** id дома realty **/
  houseId: number;
  /** Статус объявлений **/
  offerStatus?: EOfferStatus | null;
  /** Номер страницы результатов **/
  page: number;
  /** Кол-во результатов в ответе **/
  resultsOnPage: number;
  /** Количество комнат **/
  roomsCount?: ERoomsCount | null;
}

export type TGetHouseOfferHistoryDesktopResponse =
  | IGetHouseOfferHistoryDesktopResponse200
  | IGetHouseOfferHistoryDesktopResponse400;

export interface IGetHouseOfferHistoryDesktopResponse200 extends IModelResponse<IGetHouseOfferHistoryDesktopResponse> {
  statusCode: 200;
}

export interface IGetHouseOfferHistoryDesktopResponse400
  extends IModelResponse<IGetHouseOfferHistoryDesktopResponseError> {
  statusCode: 400;
}

export interface IGetHouseOfferHistoryDesktopResponse {
  /** Список найденных объявлений **/
  offers: IHouseOfferHistoryDesktopSchema[];
  /** Количество предложений для каждой комнатности. Используется на клиенте для отображения доступных комнатностей. **/
  roomCounts: IOfferHistoryRoomCountItemSchema[];
  /** Количество предложений для каждого статуса. Используется на клиенте для отображения доступных статусов. **/
  statusCounts: IOfferHistoryStatusCountItemSchema[];
  /** Общее количество объявлений в доме. Используется на клиенте для пагинации/кнопки «Загрузить ещё» **/
  totalCount: number;
}

export interface IGetHouseOfferHistoryDesktopResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetHouseOfferHistoryDesktopResponse | IGetHouseOfferHistoryDesktopResponseError;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EOfferStatus {
  /** Снято с публикации **/
  Deactivated = 'deactivated',
  /** Опубликовано **/
  Published = 'published',
}

export enum ERoomsCount {
  /** Пять комнат **/
  Five = 'five',
  /** Четыре комнаты **/
  Four = 'four',
  /** Одна комната **/
  One = 'one',
  /** Шесть и более комнат **/
  SixPlus = 'sixPlus',
  /** Студия **/
  Studio = 'studio',
  /** Три комнаты **/
  Three = 'three',
  /** Две комнаты **/
  Two = 'two',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetHouseOfferHistoryDesktopResponse): TResponse200;
  400(response: IGetHouseOfferHistoryDesktopResponseError): TResponse400;
}
